import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { TranslationModule } from '@fino-ui/translation';
import { ActionBoxComponent } from '../../components/action-box/action-box.component';
import { HeaderComponent } from '../../components/header/header.component';
import type { DWSConfig } from './dws.model';
import { DwsService } from './dws.service';

@Component({
  selector: 'app-dws',
  templateUrl: './dws.component.html',
  styleUrl: './dws.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, ActionBoxComponent, TranslationModule],
})
export class DwsComponent implements OnInit {
  constructor(private dwsService: DwsService) {}

  dwsConfig: DWSConfig;

  testUrl: string;
  prodUrl: string;

  ngOnInit(): void {
    this.dwsService.getDWSConfig().subscribe((resp) => {
      this.dwsConfig = resp;

      const { testUrl, prodUrl } = this.dwsService.getLinks(
        this.dwsConfig.tenantBaseUrl,
      );
      this.testUrl = testUrl;
      this.prodUrl = prodUrl;
    });
  }
}
